import { useEffect, useState } from 'react'
import { useRouter, useCurrentStateAndParams } from '@uirouter/react'
// helpers
import drop from 'lodash/drop'
import pick from 'lodash/pick'

export default function useStates() {
  const [section, setSection] = useState('')
  const { stateService } = useRouter()
  const { state } = useCurrentStateAndParams()

  useEffect(() => {
    const definition = stateService.target(state.name)['_definition']
    if (definition.parent.self.title === 'Puntos Ideas') setSection(definition.self.title)
    else setSection(definition.parent.self.title)
  }, [state.name])

  return {
    section
  }
}
